import React from "react";
import { useState } from 'react';
import { ConfirmationModal } from './ConfirmationModal';

const initialState = {
    show: false,
    value: "",
    isLoading: false,
    onClose: () => { },
    onConfirmation: () => { },
    configuration: {
        title: "",
        textContent: "",
        buttonText: "",
        useComment: false,
        requireComment: false,
    }
}

export default function useConfirmationModal() {
    const [modalState, setModalState] = useState(initialState);

    const _close = () => setModalState(initialState);

    const actions = {
        Show: ({ title = "", textContent = "", buttonText = "", buttonType = "success", useComment = false, requireComment = false, onConfirmation = () => { } }) => {
            setModalState({
                ...initialState, show: true, configuration: { title, textContent, buttonText, buttonType, useComment, requireComment }, onConfirmation: async (submitData) => {
                    setModalState({ ...initialState, isLoading: true })
                    try {

                        await onConfirmation(submitData)
                        setModalState({ ...initialState, isLoading: false })
                    } catch (e) {

                    }
                }
            })
        },
        Close: () => _close()
    }
    const modal = () => modalState.show == true
        ? (<ConfirmationModal state={{ ...modalState, onClose: () => _close() }} > </ConfirmationModal>)
        : null

    return [modal, actions]
};